import React from "react";

import { FaFacebookF } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { FaDribbbleSquare } from "react-icons/fa";

import "./footer.css";

const Footer = () => {
  return (
    <footer>
      <ul className="permalinks">
        <li>
          <a href="#home">Home</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#experience">Experience</a>
        </li>
        <li>
          <a href="#portfolio">Portfolio</a>
        </li>
        <li>
          <a href="#contact">Contact Me</a>
        </li>
      </ul>
      <div className="footer__socials">
        <a
          href="https://www.linkedin.com/in/tomio-koshikawa-5585ba210/"
          target="__blank"
        >
          <FaLinkedinIn />
        </a>
        <a href="https://www.facebook.com/tvk02jr/" target="__blank">
          <FaFacebookF />
        </a>

        <a href="https://dribbble.com/Tomk02" target="__blank">
          <FaDribbbleSquare />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
